/**
 * Regra de liberação: área (setor/diretoria) sozinha = todos da área;
 * área + cargo = só aquele cargo na área.
 */
export function matchesRule(rule, { sectorId, roleId, boardId } = {}) {
    if (!rule || rule.status === 'inactive') return false;
    const areaId = rule.sectorId;
    if (!areaId) return false;
    const inArea = String(areaId) === String(sectorId) || String(areaId) === String(boardId);
    if (!inArea) return false;
    if (!rule.roleId) return true;
    return String(rule.roleId) === String(roleId);
}

export function listMatchingAssignments(assignments, viewer, { resourceType } = {}) {
    return (assignments || []).filter((rule) => {
        if (resourceType && rule.resourceType !== resourceType) return false;
        return matchesRule(rule, viewer);
    });
}
